export const centerContentBoard = {
    height: 'calc(100vh - 54px)',
    width: 'calc(100% - 338px)',
    marginTop: '54px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
export const centerContentProjectSheet = {
    height: 'calc(100vh - 54px)',
    width: '100vw',
    marginTop: '54px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
export const centerContent = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
